import * as types from './action-types';
import * as verifyEmailFormApi from '../api/verify-email-form-api';
import * as apiResponseMessages from './api-response-messages';
import { beginApiCall, apiCallError } from './api-status-actions';
import * as dataFormatHelper from './helpers/data-format-helper';

export function loadSSOVerifyEmailFormDataSuccess(verifyEmailFormData) {
    return { type: types.LOAD_VERIFY_EMAIL_FORM_SUCCESS, verifyEmailFormData };
}

export function loadSSOVerifyEmailFormDataError() {
    return { type: types.LOAD_VERIFY_EMAIL_FORM_ERROR };
}

export function handleUserVerifyEmailSuccess(verifyEmailMessages) {
    return { type: types.VERIFY_EMAIL_SUCCESS, verifyEmailMessages };
}

export function handleUserVerifyEmailError(verifyEmailMessages) {
    return { type: types.VERIFY_EMAIL_ERROR, verifyEmailMessages };
}

export function resetVerifyEmailFormState() {
    return { type: types.RESET_VERIFY_EMAIL_FORM_STATE };
}

export function loadSSOVerifyEmailFormData() {
    return function (dispatch) {
        dispatch(beginApiCall());
        return verifyEmailFormApi.getSSOVerifyEmailFormData()
            .then((response) => {
                if (response.hasErrors) {
                    dispatch(apiCallError([response.errorMessage]));
                    dispatch(loadSSOVerifyEmailFormDataError());
                    return;
                }
                dispatch(loadSSOVerifyEmailFormDataSuccess(response.data));
            })
            .catch((error) => {
                dispatch(apiCallError([error]));
                dispatch(loadSSOVerifyEmailFormDataError());
                throw error;
            });
    };
}

export function handleUserVerifyEmail(verifyEmailData) {
    return function (dispatch) {
        dispatch(beginApiCall());
        return verifyEmailFormApi
            .verifyEmail(dataFormatHelper.getFormattedVerifyEmailData(verifyEmailData))
            .then((response) => {
                if (response.hasErrors) {
                    dispatch(apiCallError([response.errorMessage]));
                    dispatch(handleUserVerifyEmailError([apiResponseMessages.SERVER_ERROR_MESSAGE]));
                    return;
                }

                const { actionSuccessText } = verifyEmailData;
                dispatch(handleUserVerifyEmailSuccess([actionSuccessText]));
            })
            .catch((error) => {
                dispatch(handleUserVerifyEmailError([apiResponseMessages.SERVER_ERROR_MESSAGE]));
                dispatch(apiCallError([error]));
                throw error;
            });
    };
}
